<template>
  <section class="body">
    <div class="table-wrapper">
      <h2 class="tac">
        点名统计
        <router-link class="fz13 c-blue"
                     :to="{
            name: 'teacher_grade_manage_statistic_sign_history'
          }"
        >
          (查看历史签到)
        </router-link>
      </h2>
      <el-table :data="data.list" style="width: 100%">
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="total" label="总次数"></el-table-column>
        <el-table-column prop="in_time" label="签到"></el-table-column>
        <el-table-column prop="late" label="迟到"></el-table-column>
        <el-table-column prop="leave" label="请假"></el-table-column>
        <el-table-column prop="absent" label="旷课"></el-table-column>
      </el-table>
      <div class="pagination-wrapper tac pt10 pb10">
        <el-pagination
          :page-size="data.size"
          :layout="data.total > data.size ? 'prev, pager, next, total' : 'total'"
          :total="data.total"
          v-if="data.total > data.size"
          @current-change="getDataList"
        >
        </el-pagination>
      </div>
    </div>
  </section>
</template>

<script>
  import {
    TeacherSignStatisticsModel
  } from 'src/model/TeacherModels';

  export default {
    data() {
      return {
        data: {}
      }
    },
    computed: {
      teacherStatisticSign() {
        return TeacherSignStatisticsModel.getInstance();
      },
      // 请求体参数
      queryParams() {
        let grade_id = this.$route.params.grade_id;
        let retValue = {
          page: 1,
          size: 10
        };
        if (grade_id) {
          retValue.grade_id = grade_id;
        }
        return retValue;
      }
    },
    created() {
      this.getDataList();
    },
    methods: {
      getDataList() {
        this.teacherStatisticSign.execute(this.queryParams).then(data => {
          this.data = data;
        });
      }
    }
  }
</script>
